
namespace RioERP.Reports {

    @Serenity.Decorators.registerClass()
    export class InvoiceDetailedReportDialog extends Serenity.EntityDialog<InvoiceDetailedReportRow, any> {
        protected getFormKey() { return InvoiceDetailedReportForm.formKey; }
        protected getIdProperty() { return InvoiceDetailedReportRow.idProperty; }
        protected getLocalTextPrefix() { return InvoiceDetailedReportRow.localTextPrefix; }
        protected getNameProperty() { return InvoiceDetailedReportRow.nameProperty; }
        protected getService() { return InvoiceDetailedReportService.baseUrl; }
        protected getDeletePermission() { return InvoiceDetailedReportRow.deletePermission; }
        protected getInsertPermission() { return InvoiceDetailedReportRow.insertPermission; }
        protected getUpdatePermission() { return InvoiceDetailedReportRow.updatePermission; }

        protected form = new InvoiceDetailedReportForm(this.idPrefix);

    }
}